<div
    class="spinner position-fixed w-100 h-100 d-flex justify-content-center align-items-center"
    [class.hidden]="!(isVisible$ | async) || false"
    data-uit="spinner"
>
    <div class="overlay h-100 w-100"></div>
    <img src="assets/images/icons/loading.svg" alt="Loading..." class="spinner-icon" />
    <span class="visually-hidden">Loading...</span>
</div>
